import { Component, inject } from '@angular/core';

import { LoadingService } from './loading.service';

@Component({
  selector: 'wcg-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  standalone: false,
})
export class LoadingComponent {
  private _loading = inject(LoadingService);
  isLoading = this._loading.$loading;
}
